import ProductCategoriesApiV2 from 'api/v2/admins/product-categories-api-v2'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import ReactSelectSearchField from 'components/molecules/react-select-search-field'
import ProductCategoryService from 'domains/product-category/services'


const propTypes = {
  label              : PropTypes.string,
  required           : PropTypes.bool,
  formGroupClassName : PropTypes.string,
  id                 : PropTypes.string,
  name               : PropTypes.string,
  gender             : PropTypes.string
}

/**
 * Custom Product Attribute Categoriy Field. Build with `Formik` and `React-Select`.
 * Only to be used within a Formik component.
 *
 * Allow to select category options
 * @param {string} label - Field labe
 * @param {bool} required - It will show required badge if it's true
 * @param {object} props - other props. must be contain `name`
 */
const ProductCategorySelectField = ({
  name,
  label,
  required,
  gender,
  ...props
}) => {
  const [ options, setOptions ]     = useState([])
  const [ isLoading, setIsLoading ] = useState(true)


  useEffect(() => {
    // commented to prevent return before calling API. Tested from my side, but need to validate more
    // if (options.length > 0) return

    //* Get categories from the sessionStorage.
    //* If it is not exist, make a request to the backend to get collection of categories
    const categoriesFromCache = sessionStorage.getItem('category')
    if (categoriesFromCache && gender === sessionStorage.getItem('gender')) {
      const jsonFieldOptions = JSON.parse(categoriesFromCache)
      const formattedOptions = ProductCategoryService.formatToReactSelectOptions(jsonFieldOptions, gender)

      setOptions(formattedOptions)
      setIsLoading(false)
    }
    else {
      ProductCategoriesApiV2.get()
        .then((response) => {
          const categories = response.data.categories

          //* save the categories to the sessionStorage
          sessionStorage.setItem('category', JSON.stringify(categories))
          sessionStorage.setItem('gender', gender)

          const formattedOptions = ProductCategoryService.formatToReactSelectOptions(categories, gender)
          setOptions(formattedOptions)
          setIsLoading(false)
        })
        .catch(() => {
          alert('Failed to get categories attributes')
        })
    }
  }, [ gender ])

  const formatGroupLabel = (data) => (
    <div>
      <span><strong>{ data.label }</strong></span>
    </div>
  )

  /**
   * Get all options from grouped format react-select
   * @param {array} groupOptions - grouped format. see `ProductCategoryService.formatToReactSelectOptions`
   */
  const getOptionsFromGroupedFormat = (groupOptions) => {
    let formattedOptions = []
    groupOptions.forEach((groupOption) => {
      formattedOptions =[
        ...formattedOptions,
        ...groupOption.options
      ]
    })

    return formattedOptions
  }

  return (
    <ReactSelectSearchField
      name={ name }
      label={ label }
      required={ required }
      dataList={ options }
      isLoading={ isLoading }
      isClearable={ true }
      formatGroupLabel={ formatGroupLabel }
      getOptions={ getOptionsFromGroupedFormat }
      { ...props }
    />
  )
}

ProductCategorySelectField.propTypes = propTypes

export default ProductCategorySelectField
